import Helper from "./Helper";

class Header {
  constructor(config = {}) {
    const {
      submenuSelector,
      submenuTogglerSelector,
      menuTogglerSelector,
      menuContainerSelector,
      searchTogglerSelector,
      searchContainerSelector,
    } = config;

    this.body = document.querySelector("body");
    this.submenuToggler = document.querySelectorAll(submenuTogglerSelector);
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.submenuSelector = submenuSelector;
    this.menuToggler = document.querySelector(menuTogglerSelector);
    this.menuContainer = document.querySelector(menuContainerSelector);
    this.searchToggler = document.querySelectorAll(searchTogglerSelector);
    this.searchTogglerArray = Array.prototype.slice.call(this.searchToggler);
    this.searchContainer = document.querySelector(searchContainerSelector);
    this.searchOpen = false;
    this.submenuOpen = false;
    this.menuOpen = false;

    if (this.submenuToggler.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.menuToggler.addEventListener("click", (e) => {
      this.toggleMenu();
    });
    this.searchTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        this.toggleSearch();
      });
    });
    this.subTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleSubmenu(toggle);
      });
    });

    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllSubmenus();
        this.menuOpen = true;
        this.toggleMenu();
      }
    };
  }

  toggleSearch() {
    if (this.searchOpen) {
      this.searchTogglerArray.forEach((toggle) => {
        Helper.removeClass(toggle, "search-active");
      });
      Helper.slideUp(this.searchContainer);
      Helper.removeClass(this.body, "search-open");
      this.searchOpen = false;
    } else {
      this.searchTogglerArray.forEach((toggle) => {
        Helper.addClass(toggle, "search-active");
      });
      Helper.slideDown(this.searchContainer);
      Helper.addClass(this.body, "search-open");
      this.searchContainer.querySelector("input").focus();
      this.searchOpen = true;
    }
  }
  toggleMenu() {
    if (this.menuOpen) {
      Helper.removeClass(this.menuToggler, "burger-active");
      Helper.slideUp(this.menuContainer);
      Helper.removeClass(this.body, "menu-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.menuOpen = false;
    } else {
      Helper.addClass(this.menuToggler, "burger-active");
      Helper.slideDown(this.menuContainer);
      Helper.addClass(this.body, "menu-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.toggleMenu();
        });
      }
      this.menuOpen = true;
    }
  }

  closeAllSubmenus() {
    // console.log("close all submenus");
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    Helper.removeClass(this.body, "submenu-open");
    submenus.forEach((submenu) => {
      Helper.slideUp(submenu);
      Helper.removeClass(submenu.parentElement, "submenu-open");
    });
    if (document.querySelector(".header-backdrop")) {
      document.querySelector(".header-backdrop").remove();
    }
    this.submenuOpen = false;
  }

  toggleSubmenu(toggle) {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    const currentSubmenu = toggle.nextElementSibling;
    Helper.slideToggle(currentSubmenu);
    Helper.toggleClass(currentSubmenu.parentElement, "submenu-open");
    submenus.forEach((submenu) => {
      if (submenu != currentSubmenu) {
        Helper.slideUp(submenu);
        Helper.removeClass(submenu.parentElement, "submenu-open");
      }
    });
    submenus.forEach((submenu) => {
      if (Helper.hasClass(submenu.parentElement, "submenu-open")) {
        this.submenuOpen = true;
      }
    });
    if (this.submenuOpen) {
      Helper.addClass(this.body, "submenu-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          this.closeAllSubmenus();
        });
      }
      this.submenuOpen = false;
    } else {
      Helper.removeClass(this.body, "submenu-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.submenuOpen = true;
    }
  }
}
export default Header;
